import React from "react";

const Footer = () => {
  return (
    <footer className="mx-auto w-full max-w-container border-t py-6 bg-white text-center text-sm text-gray-500 sm:flex sm:items-center sm:justify-center">
      <p className="text-sm text-center text-gray-500">
        &copy; PT Solusi Anak Negeri
      </p>
    </footer>
  );
};

export default Footer;
